var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcArrDownEvt(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "10px",
    viewBox: "0 0 17 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icArrDownEvt") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.0690005,5.13553391 C13.0867832,5.4124928 12.9898412,5.69544016 12.7781746,5.90710678 L5.70710678,12.9781746 C5.31658249,13.3686989 4.68341751,13.3686989 4.29289322,12.9781746 C3.90236893,12.5876503 3.90236893,11.9544853 4.29289322,11.563961 L10.7213203,5.13553391 L4.29289322,-1.29289322 C3.90236893,-1.68341751 3.90236893,-2.31658249 4.29289322,-2.70710678 C4.68341751,-3.09763107 5.31658249,-3.09763107 5.70710678,-2.70710678 L12.7781746,4.36396103 C12.9898412,4.57562765 13.0867832,4.85857502 13.0690005,5.13553391 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icArrDownEvt",
    fill: "#A5A5A5",
    fillRule: "nonzero",
    transform: "translate(8.535534, 5.135534) rotate(90.000000) translate(-8.535534, -5.135534) ",
    xlinkHref: "#path-1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrDownEvt);
export default __webpack_public_path__ + "static/media/icArrDownEvt.33e718fa6bf6095f003f256e536e190b.svg";
export { ForwardRef as ReactComponent };